"use strict";
var req = require.context("./", true, /.(css|scss)$/);
req.keys().forEach(function(key) {
  req(key);
});
